<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.00008 3C4.66675 3 1.82008 5.07333 0.666748 8C1.82008 10.9267 4.66675 13 8.00008 13C11.3334 13 14.1801 10.9267 15.3334 8C14.1801 5.07333 11.3334 3 8.00008 3ZM8.00008 11.3333C6.16008 11.3333 4.66675 9.84 4.66675 8C4.66675 6.16 6.16008 4.66667 8.00008 4.66667C9.84008 4.66667 11.3334 6.16 11.3334 8C11.3334 9.84 9.84008 11.3333 8.00008 11.3333ZM6.00008 8C6.00008 6.89333 6.89341 6 8.00008 6C9.10675 6 10.0001 6.89333 10.0001 8C10.0001 9.10667 9.10675 10 8.00008 10C6.89341 10 6.00008 9.10667 6.00008 8Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
